import React, { useContext } from 'react';

import { onPrimaryAction } from 'actions/continuousFeedback';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { StyledBox, StyledTypography } from 'styles/common';

import NotAvailable from 'assets/images/NotAvailable.png';

import {
  CONTINUOUS_FEEDBACK_FORM_STATUS,
  FEEDBACK_FORM_TYPE,
  MESH_LIST_TABS,
  PAGE_TYPES,
} from 'constants/ProjectConstants';
import { pushFeedbackParams } from 'constants/helper';

import MeshListContext from '../MeshListContext';
import TasksGoalsContainer from '../TasksGoalsContainer';
import FeedbacksList from './FeedbacksList';
import LoadMoreFeedbacks from './LoadMoreFeedbacks';

const PastFeedbacks = ({ feedbacks, pageType, employee, loggedInEmployee, refreshHandler }) => {
  const dispatch = useDispatch();
  const { selectedTab, apiPaginationMeta } = useContext(MeshListContext);
  const history = useHistory();

  const isFeedbacksTabSelected = selectedTab === MESH_LIST_TABS.feedback.id;
  const isOneOnOnePage = pageType === PAGE_TYPES.oneOnOne;

  /* this is not used currently in child components */
  const handleFeedItemClick = ({
    reviewId,
    employeeId,
    submissionStatus,
    reviewProviderType,
    reviewStage,
    isReview,
    feedbackType,
    feedbackId,
    providerEmployeeId,
    isPublished,
  }) => {
    const feedbackFormType = () => {
      if (
        feedbackType === FEEDBACK_FORM_TYPE.REQUESTED &&
        String(providerEmployeeId) === String(loggedInEmployee.id) &&
        submissionStatus !== CONTINUOUS_FEEDBACK_FORM_STATUS.COMPLETED
      )
        return FEEDBACK_FORM_TYPE.PROVIDING_REQUESTED;

      if (feedbackType === FEEDBACK_FORM_TYPE.PROVIDED) return FEEDBACK_FORM_TYPE.SHOW_PROVIDED;
      if (feedbackType === FEEDBACK_FORM_TYPE.REQUESTED) return FEEDBACK_FORM_TYPE.SHOW_REQUESTED;
    };

    const feedbackFormTypeMapped = feedbackFormType();

    dispatch(onPrimaryAction(refreshHandler));

    pushFeedbackParams({
      history,
      formType: feedbackFormTypeMapped,
      typeMapped: true,
      feedbackId: reviewId,
    });
  };

  return isFeedbacksTabSelected && isOneOnOnePage ? (
    <TasksGoalsContainer>
      {feedbacks.length ? (
        <>
          <FeedbacksList feedbacks={feedbacks} handleFeedbackAction={handleFeedItemClick} />
          {apiPaginationMeta?.hasMore && <LoadMoreFeedbacks employee={employee} />}
        </>
      ) : (
        <FullHeightBox flexcontainer padding="1rem" justifycontent="center" alignitems="center" flexdirection="column">
          <StyledImage src={NotAvailable} />
          <StyledTypography topGutter={2}>No Feedbacks Found</StyledTypography>
        </FullHeightBox>
      )}
    </TasksGoalsContainer>
  ) : null;
};

export default PastFeedbacks;

const StyledImage = styled.img`
  width: 100%;
`;

const FullHeightBox = styled(StyledBox)`
  height: 100%;
`;
